export enum CHECKOUT_COM_CARD_FORM_STATES {
  INITIAL = 'INITIAL',
  ERROR = 'ERROR',
  CARD_TOKENIZED = 'CARD_TOKENIZED',
  '3D_SECURE_OPEN' = '3D_SECURE_OPEN',
  '3D_SECURE_SUCCEEDED' = '3D_SECURE_SUCCEEDED',
  COMPLETING_ORDER = 'COMPLETING_ORDER',
  ORDER_COMPLETED = 'ORDER_COMPLETED',
}
